module.exports = "<div class=\"text-editor\"></div>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader?interpolate!./src/components/text-editor/sample.html
// module id = 80
// module chunks = 0